import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import LinkRounded from "@mui/icons-material/LinkRounded";
import { Box, IconButton } from "@mui/material";
import CustomToolTip from "../../../../components/CustomTooltip";

const ScenarioSetNavigationButtons = ({
  handleClose,
  moveScenarioSet,
  disabledArrows,
  setClickUrl,
  trackEvent,
  sideDialogButtonStyle,
  UrlCopyTooltip,
}) => {
  const handleCopyUrl = () => {
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl).then();
    setClickUrl(true);
    trackEvent("user Copy Scenario " + currentUrl + " to clipboard");
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: "5%",
        right: "96%",
        zIndex: 1000, // Ensures it's above the dialog
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <IconButton onClick={handleClose} sx={sideDialogButtonStyle}>
        <CloseRoundedIcon
          sx={{ cursor: "pointer", width: "24px", height: "24px" }}
        />
      </IconButton>
      <CustomToolTip title={"View previous"} placement={"right"}>
        <IconButton
          onClick={() => moveScenarioSet("previous")}
          sx={sideDialogButtonStyle}
          disabled={disabledArrows("previous")}
        >
          <ExpandLessRoundedIcon
            sx={{
              width: "24px",
              height: "24px",
            }}
          />
        </IconButton>
      </CustomToolTip>
      <CustomToolTip title={"View next"} placement={"right"}>
        <IconButton
          onClick={() => moveScenarioSet("next")}
          sx={sideDialogButtonStyle}
          disabled={disabledArrows("next")}
        >
          <KeyboardArrowDownRoundedIcon
            sx={{
              width: "24px",
              height: "24px",
            }}
          />
        </IconButton>
      </CustomToolTip>
      <CustomToolTip title={<UrlCopyTooltip />} placement={"right"}>
        <IconButton onClick={handleCopyUrl} sx={sideDialogButtonStyle}>
          <LinkRounded
            sx={{
              width: "24px",
            }}
          />
        </IconButton>
      </CustomToolTip>
    </Box>
  );
};

export default ScenarioSetNavigationButtons;
